"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M6 0c-.55 0-1 .45-1 1v18c0 .55.32.68.71.29L9.3 15.7a.996.996 0 011.41 0l3.59 3.59c.38.39.7.26.7-.29v-8-4.5V1c0-.55-.45-1-1-1H6z"];
//# sourceMappingURL=bookmark.js.map